import actionTypes from '../actionTypes';

export function setTenant(tenant) {
    return (dispatch) => {
        dispatch({
            type: actionTypes.SET_TENANT,
            payload: tenant
        });
    }
}



// WEBPACK FOOTER //
// /src/store/actions/tenant.js